export const styles = {
  previewImage: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
  playContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '25px',
    height: '25px',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(255, 255, 255, 0.4)',
    borderRadius: '50%',
  },
  durationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    position: 'absolute',
    bottom: '1px',
    right: '4px',
  },
  durationTypo: {
    fontSize: '9px',
    color: '#fff',
    lineHeight: '146%',
    fontFamily: 'Inter',
    fontWeight: 400,
  },
  placeholderContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: '#D5D7DE',
  },
};
